const ErrorMessage = ({ message }) => (
  <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
    <p className="text-sm">{message || 'An unexpected error occurred.'}</p>
  </div>
);

export default ErrorMessage;